<div class="reports-container page-container w-100">
  <app-utility-toolbar
    class="{{ navCollapsed ? 'w-5' : 'w-15' }} vertical"
    [current]="'reporting'"
    [vertical]="true"
    [links]="dashboardLinks"
    (toggleCollapse)="toggleNavCollapse()"
  />
  <div
    class="reporting-content-container p-2"
    [ngClass]="{ collapsed: navCollapsed }"
  >
    @if (!loading) {
      <mat-tab-group #tabGroup class="w-100" [selectedIndex]="selectedTab">
        <mat-tab
          *hasPermission="'ReportRequestPortal'"
          label="Report Request Portal"
        >
          <ng-template matTabContent>
            <p class="col-12 mt-3 mb-0 title">{{ reportRequestTitle }}</p>
            <p class="col-12 subtitle">{{ reportRequestSubtitle }}</p>
            <h4 class="col-12">Request Report</h4>
            <div class="mt-2 ml-3">
              <app-report-request
                [baseUrl]="baseUrl"
                [dashboardSettings]="dashboardSettings"
              />
            </div>
          </ng-template>
        </mat-tab>
        <mat-tab
          *hasPermission="'unitSettingsReport'"
          label="Unit Settings Report"
        >
          <ng-template matTabContent>
            <h4 class="col-12 mt-3">Unit Settings Report</h4>
            <div class="mt-2 ml-3">
              <app-unit-settings [baseUrl]="baseUrl" />
            </div>
          </ng-template>
        </mat-tab>
        <mat-tab *hasPermission="'activeUsers'" label="Active Users">
          <ng-template matTabContent>
            <h4 class="col-12 mt-3">Active Users</h4>
            <div class="mt-2 ml-3">
              <app-active-users [baseUrl]="baseUrl" />
            </div>
          </ng-template>
        </mat-tab>
        <mat-tab *hasPermission="'LoadHistory'" label="Load History">
          <h4 class="col-12 mt-3">Load History</h4>
          <ng-template matTabContent>
            <app-load-history />
          </ng-template>
        </mat-tab>
        <mat-tab
          *hasPermission="'UnitProfileHistory'"
          label="Unit Profile History"
        >
          <ng-template matTabContent>
            <h4 class="col-12 mt-3">Unit Profile History</h4>
            <div class="mt-2 ml-3">
              <app-unit-profile-history [baseUrl]="baseUrl" />
            </div>
          </ng-template>
        </mat-tab>
        <mat-tab *hasPermission="'systemUnitUsageReport'" label="Unit Usage">
          <ng-template matTabContent>
            <h4 class="col-12 mt-3">Usage Report</h4>
            <div class="mt-2 ml-3">
              <app-unit-usage />
            </div>
          </ng-template>
        </mat-tab>
        <mat-tab
          *hasPermission="'unitSessionActivity'"
          label="Unit Session Activity"
        >
          <ng-template matTabContent>
            <h4 class="col-12 mt-3">Usage Session Activity</h4>
            <div class="mt-2 ml-3">
              <app-unit-session-activity />
            </div>
          </ng-template>
        </mat-tab>
        <mat-tab
          *hasPermission="'BridgeActionDetailReport'"
          label="Bridge Action"
        >
          <ng-template matTabContent>
            <h4 class="col-12 mt-3">Bridge Action Report</h4>
            <div class="mt-2 ml-3">
              <app-bridge-action />
            </div>
          </ng-template>
        </mat-tab>

        <mat-tab
          *hasPermission="'BridgeDensityReport'"
          label="Bridge Density Report"
        >
          <ng-template matTabContent>
            <h4 class="col-12 mt-3">Bridge Density Report</h4>
            <div class="mt-2 ml-3">
              <app-bridge-density />
            </div>
          </ng-template>
        </mat-tab>

        <mat-tab
          *hasPermission="'SalesTrackingReport'"
          label="Sales Tracking Report"
        >
          <ng-template matTabContent>
            <h4 class="mt-3 col-12">Sales Tracking Report</h4>
            <div class="mt-2 ml-3">
              <app-sales-tracking />
            </div>
          </ng-template>
        </mat-tab>
        <mat-tab *hasPermission="'MutualFundReport'" label="Mutual Fund Report">
          <ng-template matTabContent>
            <h4 class="mt-3 col-12">Mutual Fund Report</h4>
            <div class="mt-2 ml-3">
              <app-mutual-funds [baseUrl]="baseUrl" />
            </div>
          </ng-template>
        </mat-tab>
        <mat-tab *hasPermission="'ReasonTextReport'" label="ReasonText™ Report">
          <ng-template matTabContent>
            <div class="row col-12">
              <h4 class="col-12 mt-3">ReasonText™ Report</h4>
              <div class="mt-2 ml-3">
                <app-reason-text-report [baseUrl]="baseUrl" />
              </div>
            </div>
          </ng-template>
        </mat-tab>
        <mat-tab
          *hasPermission="'RepExceptionsReport'"
          label="Rep Exceptions Report"
        >
          <ng-template matTabContent>
            <div class="row col-12">
              <h4 class="col-12 mt-3">Rep Exceptions Report</h4>
              <div class="mt-2 ml-3">
                <app-rep-exceptions-report
                  [baseUrl]="baseUrl"
                  [alertIds]="alertIds"
                />
              </div>
            </div>
          </ng-template>
        </mat-tab>
        <mat-tab *hasPermission="'CaseManager'" label="Case Manager Reports">
          <ng-template matTabContent>
            <div class="row col-12">
              <h4 class="col-12 mt-3">Case Manager Reports</h4>
              <div class="mt-2 ml-3">
                <app-case-manager-reports [baseUrl]="baseUrl" />
              </div>
            </div>
          </ng-template>
        </mat-tab>
        <mat-tab *hasPermission="'AuditManagement'" label="Audit Management">
          <ng-template matTabContent>
            <div class="row col-12">
              <h4 class="col-12 mt-3">Audit Management</h4>
              <div class="mt-2 ml-3">
                <app-audit-management [baseUrl]="baseUrl" />
              </div>
            </div>
          </ng-template>
        </mat-tab>
      </mat-tab-group>
    }
  </div>
  <ngx-loading [show]="loading" />
</div>
